import {
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@material-ui/lab";
import {
  ButtonCancel,
  ButtonSave,
  CircleIcon,
  CloseIconStyle,
  DialogHeader,
  DialogStyle,
} from "../../../components/modal/Modal";
import MaskService from "../../../utils/mask/maskService";
import SubdirectoryArrowLeftIcon from "@material-ui/icons/SubdirectoryArrowLeft";
import { CompanyCard } from "./styles/CompanyModal";
import LogoQyonInteligence from "../../../components/logos/LogoQyonInteligence";
import listTaxRegime from "../../../utils/tax-regimes.json";
import SelectErp from "../../../components/basics/SelectErp";
import { useEffect, useState } from "react";
import { validateCaepf } from "../../../utils/validations";
import { notify } from "../../../utils/notify";

const EMPTY_CAEPF_LIST = [];

export const ModalUpdateCertificate = (props) => {
  const [selectExibition, setSelectExibition] = useState([]);
  const [caepfInputValues, setCaepfInputValues] = useState({});

  const setCaepfList = (newValue, certIndex, procIndex = null) => {
    if (!Array.isArray(newValue)) newValue = [newValue];
    const isProcuration = procIndex != null;

    if (newValue.length === 0) {
      const certList = [...props.certificateListState];
      if (isProcuration) {
        certList[certIndex].procurationCompanyList[
          procIndex
        ].company.caepf_list_documents = [];
        certList[certIndex].procurationCompanyList[procIndex].company.caepf =
          "";
      } else {
        certList[certIndex].company.caepf_list_documents = [];
        certList[certIndex].company.caepf = "";
      }
      props.setCertificateListState(certList);
      return;
    }

    const arrayLength = newValue.length - 1;
    const lastValue = newValue[arrayLength];
    const digitsOnly = String(lastValue ?? "").replace(/[^\d]/g, "");

    if (digitsOnly.length !== 14) {
      notify("CAEPF inválido. O CAEPF deve conter 14 dígitos.");
      return;
    }
    if (!validateCaepf(lastValue)) {
      notify("CAEPF inválido. Por favor, informe um CAEPF válido.");
      return;
    }

    const certList = [...props.certificateListState];
    if (isProcuration) {
      certList[certIndex].procurationCompanyList[
        procIndex
      ].company.caepf_list_documents = newValue;
      certList[certIndex].procurationCompanyList[procIndex].company.caepf =
        newValue[arrayLength];
    } else {
      certList[certIndex].company.caepf_list_documents = newValue;
      certList[certIndex].company.caepf = newValue[arrayLength];
    }
    props.setCertificateListState(certList);
  };

  useEffect(() => {
    let certificateTaxRegimes = [];

    props.certificateListState.forEach((certificate, index) => {
      let data = {
        id: index,
        taxRegime: certificate.company.tax_regime,
        procTaxRegimeList: [],
      };

      certificate.procurationCompanyList.forEach((procuration, indexProc) => {
        data.procTaxRegimeList.push(procuration.company.tax_regime);
      });

      certificateTaxRegimes.push(data);
    });

    setSelectExibition(certificateTaxRegimes);
  }, [props.certificateListState]);

  return (
    <DialogStyle>
      <DialogHeader>
        <div className="row">
          <LogoQyonInteligence></LogoQyonInteligence>

          <CloseIconStyle
            onClick={() => {
              props.closeCertificateModal();
            }}
          />
        </div>
      </DialogHeader>

      <DialogContent style={{ maxHeight: 450 }}>
        <div
          style={{
            fontSize: 21,
            fontWeight: 700,
            color: "#0036B3",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 10,
            alignItems: "center",
          }}
        >
          {props.getSecondTitle()}
        </div>

        <h3
          style={{
            fontWeight: 700,
            marginBottom: 10,
            marginTop: 0,
          }}
        >
          Selecione as empresas que deseja cadastrar:
        </h3>

        {props.certificateListState.map((certificate, index) => {
          if (certificate.action !== "procuration") {
            certificate.procurationCompanyList = [];
          }
          return (
            <>
              <Grid key={"CERTIFICATE" + index}>
                {index >= 1 && <br />}
                <CompanyCard>
                  <Grid container>
                    <Grid
                      item
                      xs={1}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        color="primary"
                        checked={certificate["inviteCreateCompany"]}
                        onChange={(ev) => {
                          certificate["inviteCreateCompany"] =
                            ev.target.checked;
                          props.setCertificateListState([
                            ...props.certificateListState,
                          ]);
                        }}
                        style={{
                          width: "20px",
                          height: "5px",
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircleIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="30"
                          fill="none"
                          viewBox="0 0 24 30"
                        >
                          <path
                            fill="#0036B3"
                            fillRule="evenodd"
                            d="M1 2.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6.382l6.553-3.276A1 1 0 0 1 15 6.5v2.382l6.553-3.276A1 1 0 0 1 23 6.5v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-20Zm2 1v18h18V8.118l-6.553 3.276A1 1 0 0 1 13 10.5V8.118l-6.553 3.276A1 1 0 0 1 5 10.5v-7H3Zm2 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4Zm2 1v2h2v-2H7Zm6-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4Zm2 1v2h2v-2h-2Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </CircleIcon>
                    </Grid>

                    <Grid item xs={9}>
                      <Typography
                        id="modal-modal-title"
                        style={{ fontWeight: 700, fontSize: 18 }}
                      >
                        {certificate.company.companyName}
                      </Typography>

                      <Typography id="modal-modal-title" variant="body2">
                        {certificate.action === "procuration" ? (
                          <b>
                            Certificado de Procuração
                            <br />
                          </b>
                        ) : (
                          ""
                        )}

                        {certificate.company.clientCnpj.length === 14 && (
                          <>
                            CNPJ:{" "}
                            {MaskService.toMask(
                              "cnpj",
                              certificate.company.clientCnpj
                            )}
                          </>
                        )}

                        {certificate.company.clientCnpj.length === 11 && (
                          <>
                            CPF:{" "}
                            {MaskService.toMask(
                              "cpf",
                              certificate.company.clientCnpj
                            )}
                          </>
                        )}
                      </Typography>

                      <Typography
                        id="modal-modal-title"
                        variant="body2"
                        style={{ marginBottom: 10 }}
                      >
                        {certificate.name}
                        <br></br>
                      </Typography>

                      {certificate?.company?.needsEmail && (
                        <TextField
                          label="Informe o e-mail de acesso para seu cliente"
                          variant="outlined"
                          key={index}
                          style={{
                            marginBottom: 20,
                            marginTop: 10,
                            width: "90%",
                          }}
                          defaultValue={""}
                          onChange={(ev) => {
                            props.certificateListState[index].company.email =
                              ev.target.value;
                          }}
                        />
                      )}

                      {selectExibition?.length > 0 && (
                        <FormControl
                          id={"tax_regime_" + index}
                          style={{
                            marginTop: 0,
                            width: "90%",
                            marginBottom: 20,
                          }}
                          size="small"
                          fullWidth
                          placeholder="Selecione o regime tributário"
                        >
                          <SelectErp
                            variant="outlined"
                            placeholder="Regime Tributário (Opcional)"
                            value={selectExibition[index]?.taxRegime}
                            setValue={(ev) => {
                              const copyList = [...selectExibition];
                              copyList[index].taxRegime = ev || null;
                              setSelectExibition(copyList);

                              props.certificateListState[
                                index
                              ].company.tax_regime = ev || null;
                            }}
                            optionsList={listTaxRegime}
                            descriptionField="description"
                          />
                        </FormControl>
                      )}

                      {certificate.company.clientCnpj.length === 11 && (
                        <>
                          <Autocomplete
                            fullWidth
                            multiple
                            id={"caepf-company-" + index}
                            options={[]}
                            freeSolo
                            value={
                              certificate.company.caepf_list_documents ??
                              EMPTY_CAEPF_LIST
                            }
                            inputValue={caepfInputValues["c-" + index] ?? ""}
                            onInputChange={(_, v) => {
                              setCaepfInputValues((prev) => ({
                                ...prev,
                                ["c-" + index]: v,
                              }));
                            }}
                            renderTags={(value, getTagProps) =>
                              (value || []).map((option, tagIdx) => (
                                <Chip
                                  key={tagIdx}
                                  label={option}
                                  style={{ backgroundColor: "#f5f5f5" }}
                                  deleteIcon={
                                    <CloseIcon
                                      style={{
                                        height: 15,
                                        color: "#202020",
                                      }}
                                    />
                                  }
                                  {...getTagProps({ index: tagIdx })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Informe o(s) CAEPF(s) do seu cliente (Opcional)"
                                variant="outlined"
                                key={index}
                              />
                            )}
                            onChange={(_, newValue) => {
                              setCaepfList(newValue, index, null);
                              setCaepfInputValues((prev) => ({
                                ...prev,
                                ["c-" + index]: "",
                              }));
                            }}
                          />

                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            style={{ marginBottom: 20 }}
                          >
                            * Aperte a tecla "Enter" para inserir os CAEPFs
                          </Typography>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </CompanyCard>

                {certificate.procurationCompanyList.map(
                  (procuration, indexProc) => {
                    return (
                      <CompanyCard style={{ marginTop: 20 }}>
                        <Grid container>
                          <Grid
                            item
                            xs={1}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              color="primary"
                              checked={procuration["inviteCreateCompany"]}
                              onChange={(ev) => {
                                procuration["inviteCreateCompany"] =
                                  ev.target.checked;
                                props.setCertificateListState([
                                  ...props.certificateListState,
                                ]);
                                if (ev.target.checked) {
                                  if (procuration?.existsInPortal) {
                                    let newList = [
                                      ...props.listCompaniesCreated,
                                    ];
                                    newList.push(procuration.company);
                                    props.setListCompaniesCreated(newList);
                                  } else {
                                    let newList = [
                                      ...props.listCompaniesNotCreated,
                                    ];
                                    newList.push(procuration.company);
                                    props.setListCompaniesNotCreated(newList);
                                  }
                                } else {
                                  if (procuration?.existsInPortal) {
                                    let newList = [
                                      ...props.listCompaniesCreated,
                                    ];
                                    newList = newList.filter(
                                      (item) =>
                                        item.clientCnpj !==
                                        procuration.company.clientCnpj
                                    );
                                    props.setListCompaniesCreated(newList);
                                  } else {
                                    let newList = [
                                      ...props.listCompaniesNotCreated,
                                    ];
                                    newList = newList.filter(
                                      (item) =>
                                        item.clientCnpj !==
                                        procuration.company.clientCnpj
                                    );
                                    props.setListCompaniesNotCreated(newList);
                                  }
                                }
                              }}
                              style={{
                                width: "20px",
                                height: "5px",
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircleIcon>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="30"
                                fill="none"
                                viewBox="0 0 24 30"
                              >
                                <path
                                  fill="#0036B3"
                                  fillRule="evenodd"
                                  d="M1 2.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6.382l6.553-3.276A1 1 0 0 1 15 6.5v2.382l6.553-3.276A1 1 0 0 1 23 6.5v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-20Zm2 1v18h18V8.118l-6.553 3.276A1 1 0 0 1 13 10.5V8.118l-6.553 3.276A1 1 0 0 1 5 10.5v-7H3Zm2 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4Zm2 1v2h2v-2H7Zm6-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4Zm2 1v2h2v-2h-2Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </CircleIcon>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography
                              id="modal-modal-title"
                              style={{
                                fontWeight: 700,
                                fontSize: 18,
                                display: "flex",
                              }}
                            >
                              {procuration.company.companyName}
                              <div style={{ marginLeft: 10 }}>
                                <Chip
                                  size="small"
                                  label="Procuração"
                                  style={{ background: "orange" }}
                                ></Chip>
                              </div>
                            </Typography>

                            <Typography id="modal-modal-title" variant="body2">
                              {certificate.action === "procuration" ? (
                                <b>
                                  Certificado de Procuração
                                  <br />
                                </b>
                              ) : (
                                ""
                              )}

                              {procuration.company.clientCnpj.length === 14 && (
                                <>
                                  CNPJ:{" "}
                                  {MaskService.toMask(
                                    "cnpj",
                                    procuration.company.clientCnpj
                                  )}
                                </>
                              )}

                              {procuration.company.clientCnpj.length === 11 && (
                                <>
                                  CPF:{" "}
                                  {MaskService.toMask(
                                    "cpf",
                                    procuration.company.clientCnpj
                                  )}
                                </>
                              )}
                            </Typography>

                            <Typography id="modal-modal-title" variant="body2">
                              {procuration.name}
                              <br></br>
                            </Typography>

                            {procuration.registerEmail && (
                              <TextField
                                label="Informe o e-mail de acesso para seu cliente"
                                variant="outlined"
                                key={index}
                                style={{
                                  marginBottom: 20,
                                  marginTop: 10,
                                  width: "90%",
                                }}
                                defaultValue={""}
                                onChange={(ev) => {
                                  procuration.company.email = ev.target.value;
                                }}
                                InputLabelProps={{
                                  style: { fontSize: "15px" },
                                }}
                              />
                            )}

                            {selectExibition[index]?.procTaxRegimeList?.length >
                              0 && (
                              <FormControl
                                style={{
                                  marginTop: 0,
                                  width: "90%",
                                  marginBottom: 20,
                                }}
                                size="small"
                                fullWidth
                                placeholder="Selecione o regime tributário"
                              >
                                <SelectErp
                                  variant="outlined"
                                  placeholder="Regime Tributário (Opcional)"
                                  value={
                                    selectExibition[index]?.procTaxRegimeList[
                                      indexProc
                                    ]
                                  }
                                  setValue={(ev) => {
                                    let copyList = [...selectExibition];
                                    copyList[index].procTaxRegimeList[
                                      indexProc
                                    ] = ev || null;
                                    setSelectExibition(copyList);
                                    procuration.company.tax_regime = ev || null;
                                  }}
                                  optionsList={listTaxRegime}
                                  descriptionField="description"
                                />
                              </FormControl>
                            )}

                            {procuration.company.clientCnpj.length === 11 && (
                              <>
                                <Autocomplete
                                  fullWidth
                                  multiple
                                  id={"caepf-proc-" + index + "-" + indexProc}
                                  options={[]}
                                  freeSolo
                                  value={
                                    procuration.company.caepf_list_documents ??
                                    EMPTY_CAEPF_LIST
                                  }
                                  inputValue={
                                    caepfInputValues[
                                      "p-" + index + "-" + indexProc
                                    ] ?? ""
                                  }
                                  onInputChange={(_, v) => {
                                    setCaepfInputValues((prev) => ({
                                      ...prev,
                                      ["p-" + index + "-" + indexProc]: v,
                                    }));
                                  }}
                                  renderTags={(value, getTagProps) =>
                                    (value || []).map((option, tagIdx) => (
                                      <Chip
                                        key={tagIdx}
                                        label={option}
                                        style={{
                                          backgroundColor: "#f5f5f5",
                                        }}
                                        deleteIcon={
                                          <CloseIcon
                                            style={{
                                              height: 15,
                                              color: "#202020",
                                            }}
                                          />
                                        }
                                        {...getTagProps({ index: tagIdx })}
                                      />
                                    ))
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      size="small"
                                      label="Informe o(s) CAEPF(s) do seu cliente (Opcional)"
                                      variant="outlined"
                                      key={index}
                                    />
                                  )}
                                  onChange={(_, newValue) => {
                                    setCaepfList(newValue, index, indexProc);
                                    setCaepfInputValues((prev) => ({
                                      ...prev,
                                      ["p-" + index + "-" + indexProc]: "",
                                    }));
                                  }}
                                />
                                <Typography
                                  variant="subtitle2"
                                  color="textSecondary"
                                  style={{ marginBottom: 20 }}
                                >
                                  * Aperte a tecla "Enter" para inserir os
                                  CAEPFs
                                </Typography>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </CompanyCard>
                    );
                  }
                )}
              </Grid>
            </>
          );
        })}
      </DialogContent>

      <DialogActions style={{ paddingRight: 20, paddingBottom: 20 }}>
        {props.disabled === false && (
          <>
            <ButtonCancel
              style={{ marginRight: 16 }}
              onClick={() => {
                if (props.disabled === false) {
                  props.closeCertificateModal();
                }
              }}
              startIcon={<SubdirectoryArrowLeftIcon />}
              disabled={props.disabled}
            >
              Cancelar
            </ButtonCancel>
            &nbsp;
          </>
        )}

        <ButtonSave
          onClick={async () => {
            props.saveUpdateCertificate();
          }}
          disabled={props.disabled}
        >
          {props.disabled ? "Carregando..." : props.textButtonSave}
        </ButtonSave>
      </DialogActions>
    </DialogStyle>
  );
};
